module.exports = __webpack_public_path__ + "img/Primordial-2.3053adae.png";